const ROUTES = {
  BUG_REPORTS: 'bug-reports',
  COMPETENCY_MAPS: 'competency-maps',
  COMPANIES: 'companies',
  USERS: 'users',
  LOGIN: 'login',
  LOGS: 'logs',
};

export default ROUTES;
